import React, { Component } from "react";
import { Form, Input, Checkbox } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

const dataField = [
  {
    title: "Tên tài khoản",
    fieldName: "account_name",
  },
  {
    title: "Tên đăng nhập",
    fieldName: "signup_name",
  },
  {
    title: "Password",
    fieldName: "password",
  },
];

export class AccountInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeEye: false,
      showPassword: true,
    };
  }

  checkEditPass = (e) => {
    this.props.checkEditPass(e.target.value);
    this.setState({
      activeEye: true,
    });
  };

  showPassword = () => {
    this.setState({ showPassword: true });
  };

  hidePassword = () => {
    this.setState({ showPassword: false });
  };

  render() {
    const { typeOption, editable } = this.props;
    const { activeEye, showPassword } = this.state;
    return (
      <>
        <div style={{ position: "relative" }}>
          {dataField.map((field) => {
            return (
              <Form.Item
                wrapperCol={15}
                key={field.fieldName}
                label={`* ${field.title}::`}
                name={field.fieldName}
                rules={
                  field.fieldName === "account_name"
                    ? [
                        {
                          required: true,
                          message: `Vui lòng nhập Tên tài khoản!`,
                        },
                        {
                          max: 255,
                          message: "Tên tài khoản vượt quá 255 ký tự!",
                        },
                      ]
                    : []
                }
              >
                <Input
                  className={
                    field.fieldName === "password" && showPassword
                      ? "text-security"
                      : ""
                  }
                  disabled={
                    !editable ||
                    field.fieldName === "signup_name" ||
                    (field.fieldName === "password" &&
                      typeOption === "create_new")
                  }
                  placeholder={`${field.title}`}
                  onChange={
                    field.fieldName === "password" ? this.checkEditPass : null
                  }
                />
              </Form.Item>
            );
          })}
          <span
            className={
              typeOption !== "edit" || !activeEye
                ? "block-click pass-visible"
                : "pass-visible"
            }
          >
            {!showPassword && <EyeOutlined onClick={this.showPassword} />}
            {showPassword && (
              <EyeInvisibleOutlined onClick={this.hidePassword} />
            )}
          </span>
        </div>
      </>
    );
  }
}
